import { useCallback, useRef, useState } from "react";
import { withLoadingToast } from "utils/withLoadingToast";
import { fetchInvoicePdf } from "../services/InvoiceService";

export function useViewInvoicePdf() {
  const [loadingId, setLoadingId] = useState<number | null>(null);
  const inFlight = useRef(false);

  const viewPdf = useCallback(async (id: number) => {
    if (inFlight.current) return;
    inFlight.current = true;
    setLoadingId(id);
    await withLoadingToast(
      "Generating PDF…",
      async () => {
        const blob = await fetchInvoicePdf(id);
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank", "noopener,noreferrer");
        setTimeout(() => URL.revokeObjectURL(url), 10_000);
      },
      "PDF ready",
      "Failed to generate PDF. Please try again.",
    ).finally(() => {
      inFlight.current = false;
      setLoadingId(null);
    });
  }, []);

  return { viewPdf, loadingId };
}
